<template lang="html">
	<div class="view-nav-template patrimonial-landscape white-box row">
		<div class="menu column">
			<div class="title row">
				<span class="icon-eye"></span>
				<div class="ctn-title column">
					<div class="label row">
						Paysage Patrimonial
					</div>
					<div class="subtitle" v-if="estate">
            <template v-if="estate.completedAt">
              Signé le {{ estate.completedAt }}
            </template>
            <template v-else-if="!isAnonymous">
              Non signé
            </template>
					</div>
				</div>
			</div>
			<!-- <div class="btn btn-gold" @click="displayLegalEstate = true">
				Informations Légales
			</div> -->
		</div>
		<div class="view column">
			<div class="head row">
				<div class="label" v-if="estate && estate.updatedAt">
					<!-- TODO : Moment this shit -->
					Mise à jour du {{ estate.updatedAt }}
				</div>
				<div class="label" v-else>
					Pas de paysage patrimonial existant
				</div>
				<div class="ctn-cta">
					<button class="btn btn-gold" :class="{'btn-disabled': !canDownload}" :disabled="!canDownload" @click="downloadEstate()" v-if="!isAnonymous">
						<span class="icon-button-download"></span> Télécharger mon Paysage Patrimonial
					</button>
					<router-link tag="button" :to="{name: 'PatrimonialLandscapeUpdate'}" class="btn btn-red">
						Mettre à jour
					</router-link>
				</div>
			</div>
<!-- 
			<div style="font-size: 11pt">
				Avant de remplir votre Paysage Patrimonial, merci de prendre connaissance de <a href="#" @click="displayRgpdModal = true" style="text-decoration: underline;">ces informations légales importantes</a>.
			</div> -->
			<div class="ctn-component">
				<div class="ctn-tile row">
					<div class="tile column">
						<div class="head-tile row">
							<div class="title">Vous</div>
							<span class="icon-paysage-vous"></span>
						</div>
						<div class="body-tile">
							<div class="item row">
								<div class="label">Age</div>
								<div class="value">{{ birthdate }}</div>
							</div>
							<div class="item row">
								<div class="label">Métier</div>
								<div class="value">{{ estate.job || '-'}}</div>
							</div>
							<div class="item row">
								<div class="label">CSP</div>
								<div class="value">{{ estate.csp || '-' }}</div>
							</div>
							<div class="item row">
								<div class="label">Statut</div>
								<div class="value">{{ estate.maritalStatus || '-' }}</div>
							</div>
						</div>
					</div>
					<div class="tile column">
						<div class="head-tile row">
							<div class="title">Avoirs & Rentrées</div>
							<span class="icon-paysage-rentree"></span>
						</div>
						<div class="body-tile">
							<div class="item row">
								<div class="label">Revenu annuel</div>
								<div class="value">{{ estate.total.incomes || '-' }}</div>
							</div>
							<div class="item row">
								<div class="label">Immobilier</div>
								<div class="value">{{ estate.total.immobilier || '-' }}</div>
							</div>
							<div class="item row">
								<div class="label">Epargne</div>
								<div class="value">{{ estate.total.savings || '-' }}</div>
							</div>
							<!-- <div class="item row">
								<div class="label">Bien & créances</div>
								<div class="value">-</div>
							</div> -->
						</div>
					</div>
					<div class="tile column">
						<div class="head-tile row">
							<div class="title">Sorties</div>
							<span class="icon-paysage-sortis"></span>
						</div>
						<div class="body-tile">
							<div class="item row">
								<div class="label">Hors impots</div>
								<div class="value">{{ estate.spendingNoTaxes.value || '-' }} {{ (estate.spendingNoTaxes.value) ? estate.spendingNoTaxes.cur : '' }}</div>
							</div>
							<div class="item row">
								<div class="label">Crédit</div>
								<div class="value">{{ estate.total.loans || '-' }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="ctn-tile row">
					<div class="tile column">
						<div class="head-tile row">
							<div class="title">Fiscalité</div>
							<span class="icon-paysage-fiscalite"></span>
						</div>
						<div class="body-tile">
							<div class="item row">
								<div class="label">Impôt sur le revenu</div>
								<div class="value">{{ estate.taxes.value || '-' }} {{ (estate.taxes.value) ? estate.taxes.cur : '' }}</div>
							</div>
							<div class="item row">
								<div class="label">Déclaration ISF</div>
								<div class="value">{{ estate.isf.amount || '-' }} {{ (estate.taxes.value) ? estate.isf.cur : '' }}</div>
							</div>
						</div>
					</div>
					<div class="tile column">
						<div class="head-tile row">
							<div class="title">Retraite</div>
							<span class="icon-paysage-retraite"></span>
						</div>
						<div class="body-tile">
							<div class="item row">
								<div class="label">Départ retraite</div>
								<div class="value">{{ estate.retreat.month || '-' }} {{ estate.retreat.year }}</div>
							</div>
							<div class="item row">
								<div class="label">PERP</div>
								<div class="value">{{ PERPcomputed }}</div>
							</div>
						</div>
					</div>
					<div class="tile column">
						<div class="head-tile row">
							<div class="title">Profil</div>
							<span class="icon-paysage-profil"></span>
						</div>
						<div class="body-tile">
							<div class="item row">
								<div class="label">Suivi</div>
								<div class="value">{{ estate.follow.rate || '-' }}</div>
							</div>
							<div class="item row">
								<div class="label">Connaissance</div>
								<div class="value">{{ estate.knowledge.level || '-' }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<base-modal :show="displayLegalEstate" @close="displayLegalEstate = false" :content="contentModalLegalEstate" />
		<base-modal :show="displayRgpdModal" @close="displayRgpdModal = false" :content="contentModalRgpd" />
	</div>
</template>

<script>
import emma from '../../services/Emma'
import ModalLegalEstate from './modal/LegalEstate'
import ModalRgpd from './modal/Rgpd'
import { mapGetters } from 'vuex'

export default {
	name: 'display',
	data () {
		return {
			PERPcomputed: '',
			displayLegalEstate: false,
			displayRgpdModal: false,
			contentModalLegalEstate: ModalLegalEstate,
			contentModalRgpd: ModalRgpd
		}
	},
	mounted () {
		if (this.estate.retreat !== undefined) {
			if (this.estate.retreat.PERP) {
				this.estate.retreat.PERP.forEach((perp) => {
					this.PERPcomputed += perp + ', '
				})
			}
		}
		this.PERPcomputed = this.PERPcomputed.substring(0, this.PERPcomputed.length - 2)
		if (this.PERPcomputed === '') { this.PERPcomputed = '-' }
	},
	methods: {
		downloadEstate () {
			if (!(this.estate && this.estate.updatedAt && !this.isForceCompleteProfile)) {
				return
			}

			emma.get('api/estate/private/doc/' + this.estate.idUser).then((result) => {
				const win = window.open(process.env.API_ROOT + result.data.file.substring(1, result.data.file.length))
				win.focus()

				if (this.isAnonymous) {
					this.$store.dispatch('setForceCompleteProfileAsTrue')
				}
			}).catch((error) => {
				console.warn(error)
			})
		}
	},
	computed: {
		...mapGetters({
			estate: 'estate',
			isAnonymous: 'isAnonymous',
			isForceCompleteProfile: 'isForceCompleteProfile'
		}),
		birthdate () {
			const date = this.$moment(this.estate.birthdate, 'YYYY-MM-DD')
			return (date.isValid()) ? `${this.$moment().diff(this.estate.birthdate, 'years')} ans` : '-'
		},
		canDownload () {
			return this.estate && this.estate.updatedAt && !this.isForceCompleteProfile
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Display.vue?088e2a70